import { useEffect, useState } from 'react';
import { useMotionValue, MotionValue } from 'framer-motion';
import { GridLayout } from './use-grid-layout';
import { calculateGridIndex, calculateScrollPosition, getCenterOfGridIndex } from './helpers';

export const useScrollPosition = (
  gridLayout: GridLayout
): { x: MotionValue; y: MotionValue; scrollBase: { x: number; y: number } } => {
  const scrollX = useMotionValue(0);
  const scrollY = useMotionValue(0);
  const [scrollBase, setScrollBase] = useState({ x: 0, y: 0 });

  // once grid layout changes, determine new scroll position
  useEffect(() => {
    if (!gridLayout.containerWidth || !gridLayout.containerHeight) {
      return;
    }

    let index;

    // calculate index based on scroll position or alternatively on init pick the center item
    if (scrollX.get() && scrollY.get()) {
      index = calculateGridIndex(scrollX.get(), scrollY.get(), gridLayout);
    } else {
      index = getCenterOfGridIndex(gridLayout.layout);
    }
    const [x, y] = calculateScrollPosition(index, gridLayout);

    scrollX.set(x);
    scrollY.set(y);
    setScrollBase({ x, y });
  }, [gridLayout, scrollX, scrollY]);

  return { x: scrollX, y: scrollY, scrollBase };
};
